import { render, staticRenderFns } from "./AdminAccess.vue?vue&type=template&id=49667810&scoped=true"
import script from "./AdminAccess.vue?vue&type=script&lang=ts"
export * from "./AdminAccess.vue?vue&type=script&lang=ts"
import style0 from "./AdminAccess.vue?vue&type=style&index=0&id=49667810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49667810",
  null
  
)

export default component.exports